import { GridOptions } from 'ag-grid-community';

const CropStateSchema: GridOptions = {
  columnDefs: [
    {
      headerName: '임산물이름',
      field: 'tree_kind_nm',
      flex: 1,
      minWidth: 100,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: '검출면적(㎡)',
      field: 'area',
      flex: 1,
      minWidth: 118,
      cellStyle: { textAlign: 'center' },
    },
  ],
};
const CropAiFeatureList: GridOptions = {
  columnDefs: [
    {
      headerName: '위치',
      field: 'wkt',
      flex: 1,
      width: 62,
      maxWidth: 62,
      minWidth: 62,
      cellStyle: {
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      },
      cellRenderer: () => {
        return (
          <button
            type="button"
            className="bLocation2"
          >
            <span>위치보기</span>
          </button>
        );
      },
    },
    {
      headerName: '주소',
      field: 'addr',
      flex: 1,
      minWidth: 250,
      autoHeight: true,
      cellStyle: {
        textAlign: 'left',
        whiteSpace: 'wrap',
        height: 'auto',
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        cursor: 'pointer',
      },
    },
    {
      headerName: '검출임산물',
      field: 'tree_kind_nm',
      flex: 1,
      minWidth: 86,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
    },
    {
      headerName: '검출면적',
      field: 'area',
      flex: 1,
      minWidth: 90,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
    },
  ],
};

const CropAiTransition: GridOptions = {
  columnDefs: [
    {
      headerName: '작물이름',
      field: 'ai_cltv_nm',
      flex: 1,
      minWidth: 140,
      cellStyle: { textAlign: 'center' },
    },
  ],
};

const CultureStateSchema: GridOptions = {
  columnDefs: [
    {
      headerName: '비율(%)',
      field: 'rate',
      flex: 1,
      valueGetter: (params) => {
        const total = params.getValue('tot_count');
        const value = params.getValue('reg_count');

        return ((value / total) * 100).toFixed(2);
      },
      minWidth: 90,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: '신고면적(㎡)',
      field: 'reg_area',
      flex: 1,
      minWidth: 176,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: '신고건수(건)',
      field: 'reg_count',
      flex: 1,
      minWidth: 140,
      cellStyle: { textAlign: 'center' },
    },
    {
      hide: true,
      field: 'tot_count',
    },
  ],
};

const CultureDetailList: GridOptions = {
  columnDefs: [
    {
      headerName: '위치',
      field: 'wkt',
      flex: 1,
      width: 48,
      maxWidth: 48,
      minWidth: 48,
      cellStyle: {
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      },
      cellRenderer: () => {
        return (
          <button
            type="button"
            className="bLocation2"
          >
            <span>위치보기</span>
          </button>
        );
      },
    },
    {
      headerName: '소재지',
      field: 'reg_addr',
      flex: 1,
      minWidth: 124,
      autoHeight: true,
      cellStyle: {
        textAlign: 'left',
        whiteSpace: 'wrap',
        height: 'auto',
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        cursor: 'pointer',
      },
    },
    {
      headerName: '농장주',
      field: 'user_nm',
      flex: 1,
      minWidth: 70,
      autoHeight: true,
      cellStyle: {
        textAlign: 'center',
        whiteSpace: 'wrap',
        height: 'auto',
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
      },
    },
    {
      headerName: '지적면적(㎡)',
      field: 'land_area',
      flex: 1,
      minWidth: 72,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
    },
    {
      headerName: '신고면적(㎡)',
      field: 'cltv_area',
      flex: 1,
      minWidth: 72,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
    },
    {
      headerName: '재배작물',
      field: 'reg_cltv_nm',
      flex: 1,
      minWidth: 80,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
    },
    {
      headerName: 'AI 분석 비교',
      field: 'same_nm',
      flex: 1,
      minWidth: 80,
      cellStyle: { textAlign: 'center', cursor: 'pointer' },
      cellClassRules: {
        'cell-pass': (params) => params.value === '일치',
        'cell-fail': (params) => params.value === '부분일치' || params.value === '불일치',
      },
    },
  ],
};

const CultureTransition: GridOptions = {
  columnDefs: [
    {
      headerName: '작물이름',
      field: 'reg_cltv_nm',
      flex: 1,
      minWidth: 100,
      cellStyle: { textAlign: 'center' },
    },
  ],
};

interface ICropSchema {
  statistics: GridOptions;
  aiFeatureList: GridOptions;
  aiTransition: GridOptions;

  cultureStat: GridOptions;
  cultureDetailList: GridOptions;
  cultureTransition: GridOptions;
}

const CropSchema: ICropSchema = {
  statistics: CropStateSchema,
  aiFeatureList: CropAiFeatureList,
  aiTransition: CropAiTransition,
  cultureStat: CultureStateSchema,
  cultureDetailList: CultureDetailList,
  cultureTransition: CultureTransition,
};

export { CropSchema };
